import 'styled-components/macro'
import { styled, useTheme } from 'styled-components'
import React from 'react'
import OptionalMarkdown from '../Markdown/OptionalMarkdown'
import { MediaObj } from '@mission.io/question-toolkit'
import { Thumbnail } from '../../assets/img'
import { ImageViewer } from '../../assets/styles'
import Popover from '../../components/popover'
import { _tempTheme } from '../../utils/tempTheme'

/**
 * A simple wrapper for a student review question component. Lines up the index and the question component.
 * @param {{index: number. children: React.ReactNode}} props
 * @returns {JSX.Element} a wrapper for a student review question
 */
export default function StudentReview(props: {
	index?: number
	prompt: string
	children: React.ReactNode
	media?: MediaObj[]
}): JSX.Element {
	const { index, children, prompt } = props
	const displayIndex: number | false = index ?? false
	const theme = useTheme()

	return (
		<ReviewWrapper>
			{displayIndex !== false && (
				<BoldSpan style={{ marginRight: '.5em' }}>{displayIndex + 1}.</BoldSpan>
			)}

			<div className="body">
				<BoldSpan>
					<OptionalMarkdown className="prose-on-game-light-purple">
						{prompt}
					</OptionalMarkdown>
					{props.media?.[0] && (
						<Popover
							arrowColor={theme.white}
							triggerStyle={{ display: 'inline-flex' }}
							trigger={
								<img
									alt={`Media for question prompt: ${prompt}.`}
									src={Thumbnail}
									css={`
										width: ${_tempTheme.spacing4};
										height: ${_tempTheme.spacing4};
										transform: translateY(2px);
										cursor: pointer;
										margin-left: ${_tempTheme.spacing2};
									`}
								/>
							}>
							<ImageViewer
								alt={`Media for question: ${prompt}`}
								src={props.media?.[0].url}
							/>
						</Popover>
					)}
				</BoldSpan>
				{children}
			</div>
		</ReviewWrapper>
	)
}

const ReviewWrapper = styled.div`
	background-color: transparent;
	display: flex;

	.body {
		flex: 1;
		text-align: left;
	}
`

const BoldSpan = styled.span`
	font-weight: ${_tempTheme.font_bold};
`
